export const STATIONS = [
	{
		id: 1,
		name: "101.5 K-Rock",
		description: "Mainstream rock anthems with a sharp Manhattan edge.",
		image: "/stations/krock-1015.jpg",
		url: "https://stream-01.surfernetwork.com/drscz5r6naxuv?zt=eyJhbGciOiJIUzI1NiJ9.eyJzdHJlYW0iOiJkcnNjejVyNm5heHV2IiwiaG9zdCI6InN0cmVhbS0wMS5zdXJmZXJuZXR3b3JrLmNvbSIsInRtIjpmYWxzZSwicnR0bCI6NSwianRpIjoiejRVdTlWSGlRcHloZ3lLZlNiMDZGQSIsImlhdCI6MTc3NTkzNTc1NiwiZXhwIjoxNzc1OTM1ODE2fQ.xtM3hBBV3OJdYc1ITgSnPVX_bEnHy1SVtRmwF-7uQ3A",
		nowPlayingUrl: "/api/metadata/surfer/drscz5r6naxuv",
		nowPlayingFormat: "json",
	},
	{
		id: 2,
		name: "90.9 The Bridge",
		description: "Indie and alt cuts from Kansas City with a gritty streak.",
		image: "/stations/thebridge-909.jpg",
		url: "https://prod-13-222-197-5.amperwave.net/publictv19-ktbgfmaac-hlsc1.m3u8/?z=4aaa46288d4f48218b7c9f56b17116fb&p=1",
		nowPlayingUrl: "/api/metadata/bridge",
		nowPlayingFormat: "json",
	},
	{
		id: 3,
		name: "106.7 KROQ",
		description: "Pasadena alt-rock staples with fresh tracks and late-night bite.",
		image: "/stations/kroq-1067.jpg",
		url: "https://prod-18-234-58-253.amperwave.net/audacy-kroqfmaac-hlsc.m3u8",
		nowPlayingUrl: "/api/metadata/audacy/101-299",
		nowPlayingFormat: "json",
	},
	{
		id: 5,
		name: "91.9 Wildcat",
		description: "The longest-continuously running college FM station in the nation.",
		image: "/stations/wildcat919.jpg",
		url: "https://s.radiowave.io/ksdb.mp3"
	},
	{
		id: 11,
		name: "96.3 X96",
		description: "Utah's Original Alternative for over 30 years along the Wasatch Front with Radio From Hell in the mornings",
		image: "/stations/x96.jpg",
		url: "https://das-edge59-sa48-futuri-lax02.cdnstream.com/7346_48k.aac",
		nowPlayingUrl: "/api/metadata/cdnstream/7346_48k",
		nowPlayingFormat: "json",
	},
	{
		id: 12,
		name: "102.7 EQX",
		description: "EQX is live, local, independent, alternative radio, originating from Manchester",
		image: "/stations/weqx1027.jpg",
		url: "https://stream-01.surfernetwork.com/cc6a319f460vv?zt=eyJhbGciOiJIUzI1NiJ9.eyJzdHJlYW0iOiJjYzZhMzE5ZjQ2MHZ2IiwiaG9zdCI6InN0cmVhbS0wMS5zdXJmZXJuZXR3b3JrLmNvbSIsInRtIjpmYWxzZSwicnR0bCI6NSwianRpIjoiNnFQdXJtX21UVHV5R0R0UWE2WURKQSIsImlhdCI6MTc3NTk2MjA1NCwiZXhwIjoxNzc1OTYyMTE0fQ.Bxw9fo--KCaGBvOrTG9StPZbENblXkRyTN7hFPsXNu0",
		nowPlayingUrl: "/api/metadata/surfer/cc6a319f460vv",
		nowPlayingFormat: "json",
	},
	{
		id: 13,
		name: "105.9 The Rock",
		description: "Nashville's Only Classic Rock",
		image: "stations/therock1059.jpg",
		url: "https://n18a-e2.revma.ihrhls.com/zc2780/24_12qlhwezogl9602/playlist.m3u8?streamid=2780&zip=&aw_0_1st.playerid=iHeartRadioWebPlayer&aw_0_1st.skey=12299580791&clientType=web&companionAds=false&deviceName=web-mobile&dist=iheart&host=webapp.US&listenerId=1b87436d18d8bfeb5df665627213d8ee&playedFrom=157&pname=live_profile&profileId=12299580791&stationid=2780&terminalId=159&territory=US",
		nowPlayingUrl: "/api/metadata/iheart/2780",
		nowPlayingFormat: "json",
	},
	{
		id: 14,
		name: "92.3 K-Rock 90's",
		description: "92.3 K-Rock 90's brings back the '90s spirit with a mix of Rock and Alternative hits",
		image: "/stations/krock923.jpg",
		url: "https://streaming.live365.com/a76295/playlist.m3u8",
		nowPlayingUrl: "/api/metadata/live365/a76295",
		nowPlayingFormat: "json",
	},
	{
		id: 15,
		name: "95.5 Rock",
		description: "This is Smoky Hills Rock 95.5. From McPherson to Salina, we rock the Smoky Hills!",
		image: "/stations/rock955.jpg",
		url: "https://us2.maindigitalstream.com/ssl/KLBQ",
		nowPlayingUrl: "/api/metadata/maindigitalstream/2072",
		nowPlayingFormat: "json",
	},
	{
		id: 16,
		name: "1150 KSAL NewsRadio",
		description: "KSAL is Salina's heritage news, sports, and talk radio station.",
		url: "https://ice23.securenetsystems.net/KSALAM",
		image: "/stations/ksal1150.png",
	},
	{
		id: 17,
		name: "104.9 KSAL",
		description: "FM 104.9 - KSAL-FM, Your Home for the 104 Minute Music Sweep!",
		url: "https://ice23.securenetsystems.net/KSALFM",
		image: "/stations/ksal1049.png",
		nowPlayingUrl: "/api/metadata/securenet/streamdb8web/KSALFM",
		nowPlayingFormat: "json",
	},
	{
		id: 19,
		name: "98.9 The Rock",
		description: "Kansas City's Rock Station. KQRC-FM is spinning the best Rock, live from Kansas City.",
		image: "/stations/rock989.jpg",
		url: "https://prod-18-234-58-253.amperwave.net/audacy-kqrcfmaac-hlsc.m3u8/",
		nowPlayingUrl: "/api/metadata/audacy/101-919",
		nowPlayingFormat: "json",
	},
	{
		id: 20,
		name: "107.5 FM / 910 AM KINA",
		description: "Big Coverage Area Local Programs / Kansas City Chiefs / Fox News Top-rated talk show hosts including Michael Savage, Mark Levin, & Joe Pags",
		image: "/stations/910kina.jpg",
		url: "https://ice10.securenetsystems.net/KINA",
		nowPlayingUrl: "/api/metadata/securenet/streamdb7web/KINA",
		nowPlayingFormat: "json",
	},
	{
		id: 21,
		name: "94.5 Prime FM",
		description: "Playing the greatest hits on earth!",
		image: "/stations/945prime.png",
		url: "https://ice42.securenetsystems.net/KSKGHD2",
		nowPlayingUrl: "/api/metadata/securenet/streamdb9web/KSKGHD2",
		nowPlayingFormat: "json",
	},
	{
		id: 4,
		name: "SomaFM Indie Pop Rocks!",
		description: "Indie-pop and alt-rock cuts with a bright West Coast edge.",
		image: "stations/somaindiepoprocks.jpg",
		url: "https://ice6.somafm.com/indiepop-128-aac",
		nowPlayingUrl: "https://somafm.com/recent/indiepop.tre.xml",
	},
	{
		id: 6,
		name: "Radio Paradise Rock Mix",
		description: "Eclectic rock sequencing with deeper cuts and polished flow.",
		image: "stations/radioparadiserockmix.jpg",
		url: "https://stream.radioparadise.com/rock-flac",
		nowPlayingUrl: "/api/metadata/radioparadise?chan=2",
		nowPlayingFormat: "json",
	},
	{
		id: 7,
		name: "Purrple Cat",
		description: "24/7 LoFi Radio by Purrple Cat. Original dreamy instrumental chill beats to study, relax, sleep, focus & work to",
		image: "stations/purplecat.jpg",
		url: "https://streaming.live365.com/a30440/playlist.m3u8",
		nowPlayingUrl: "/api/metadata/live365/a30440",
		nowPlayingFormat: "json",
	},
	{
		id: 8,
		name: "Megarock Radio",
		description: "Hard rock and classic metal with a bigger, louder feel.",
		image: "stations/megarockradio.jpg",
		url: "https://stream3.megarockradio.net:80/",
		nowPlayingUrl: "/api/metadata/megarock",
		nowPlayingFormat: "text",
	},
	{
		id: 9,
		name: "The Independent FM",
		description: "Modern indie-rock rotation with a sharper club-night tone.",
		image: "stations/theindependentfm.jpg",
		url: "https://listen.radioking.com/radio/293701/stream/340084",
		nowPlayingUrl: "https://api.radioking.io/widget/radio/the-independent-fm-1/track/current",
		nowPlayingFormat: "json",
	},
	{
		id: 10,
		name: "Radio Rock On",
		description: "Straight-up classic rock riffs with a gritty throwback pulse.",
		image: "stations/radiorockon.png",
		url: "https://streaming.radiostreamlive.com/radiorockon_devices",
	}
];